// extracted by mini-css-extract-plugin
module.exports = {"imageGallery":"ImageGallery_imageGallery__2ZXmA"};